/*!
 * hb-animations.js — Héritage Botanique
 * Scroll reveal + stagger system
 */
(function () {
  'use strict';

  if (window.hbAnimInit) return;
  window.hbAnimInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Selectors to animate — stagger:true groups siblings within same parent
  var TARGETS = [
    { sel: '.section-rich-text .rich-text__heading' },
    { sel: '.section-rich-text .rich-text__text', delay: 110 },
    { sel: '.section-rich-text .rich-text__buttons', delay: 220 },
    { sel: '.image-with-text .image-with-text__media' },
    { sel: '.image-with-text .image-with-text__text-item', delay: 130 },
    { sel: '.hb-oval-card', stagger: true },
    { sel: '.card-wrapper', stagger: true },
    { sel: '.hb-stats-band__item', stagger: true },
    { sel: '.multicolumn-card', stagger: true },
    { sel: '.section-multirow .multirow__grid' },
    { sel: '.newsletter__heading' },
    { sel: '.newsletter .field', delay: 110 }
  ];

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('hb-visible');
      observer.unobserve(el);
      // Remove reveal classes after transition so hover transforms are unblocked
      el.addEventListener('transitionend', function cleanup(e) {
        if (e.propertyName !== 'opacity') return;
        el.classList.remove('hb-reveal', 'hb-visible');
        el.removeEventListener('transitionend', cleanup);
      });
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

  function observe(el, delay) {
    el.classList.add('hb-reveal');
    if (delay) el.style.transitionDelay = delay + 'ms';
    observer.observe(el);
  }

  function init() {
    TARGETS.forEach(function (cfg) {
      var els = Array.from(document.querySelectorAll(cfg.sel));
      if (!els.length) return;

      if (cfg.stagger) {
        var groups = new Map();
        els.forEach(function (el) {
          var key = el.parentElement;
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(el);
        });
        groups.forEach(function (children) {
          children.forEach(function (el, i) { observe(el, i * 90); });
        });
      } else {
        els.forEach(function (el) { observe(el, cfg.delay || 0); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
